import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesCopyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-copy',
	path: '/secure/admin/ViewCopyIssueTypeScreenScheme.jspa',
};
